export class AiCdsAlertAction {

    static readonly type = '[AiCdsAlert] AiCdsAlert';

    constructor(public payload: any) {
    }
}
export class DsiRecommAction {

    static readonly type = '[dsirecomalrts] dsirecomalrts';

    constructor(public payload: any) {
    }
}

